import type { EventShowroom as EventShowroomContent } from '../data/events';

function EventShowroom({ showroom }: { showroom: EventShowroomContent }) {
  return (
    <section className="home-section event-detail-showroom" aria-labelledby="event-showroom-heading">
      <div className="section-inner">
        <h2 id="event-showroom-heading">{showroom.title}</h2>
        <p className="event-showroom-intro">{showroom.intro}</p>
        <ul className="event-showroom-grid">
          {showroom.topics.map((topic) => (
            <li key={topic.title} className="event-showroom-card">
              <div className="event-showroom-plate">
                <div className="event-showroom-visual">
                  <img src={topic.image} alt="" />
                  <span className="event-showroom-overlay" aria-hidden="true" />
                  <ul className="event-showroom-tags">
                    {topic.tags.map((tag) => (
                      <li key={tag}>{tag}</li>
                    ))}
                  </ul>
                </div>
                <h3>{topic.title}</h3>
              </div>
              <div className="event-showroom-copy">
                {topic.sentences.map((sentence) => (
                  <p key={sentence}>{sentence}</p>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default EventShowroom;
